<nz-spin [nzSpinning]="isLoading" nzSize="large" [nzTip]="spinnerMessage">
  <div>
    <div class="login-welcome">
      Welcome back
    </div>
    <h1 class="login-title">
      Sign in to continue
    </h1>

    <!-- Error Display Component -->
    <div class="mt-4">
      <app-error-display
        *ngIf="showError()"
        [error]="errorDetails"
        [showRetry]="true"
        (retry)="onRetryLogin()"
        (dismiss)="onDismissError()"
      >
      </app-error-display>
    </div>

    <form #loginForm (ngSubmit)="login()" [formGroup]="form" class="login-form">
      <label class="block">
        <span class="block mb-1 text-sm font-medium login-label">Email</span>
        <input
          #emailInput
          class="form-input input input-bordered input-md rounded-lg w-full"
          autocomplete="username"
          formControlName="email"
          inputmode="email"
          name="email"
          placeholder="Ex. james@bond.com"
          required
          type="email"
        />
      </label>
      <label class="block">
        <span class="block mb-1 text-sm font-medium login-label">Password</span>
        <div class="relative">
          <input
            class="form-input input input-md input-bordered rounded-lg w-full pr-24"
            autocomplete="current-password"
            formControlName="password"
            name="password"
            placeholder=""
            required
            [type]="isPasswordVisible() ? 'text' : 'password'"
            aria-label="Password"
          />
          <button
            type="button"
            tabindex="-1"
            class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
            (click)="isPasswordVisible.set(!isPasswordVisible())"
            aria-label="Toggle password visibility"
          >
            {{ isPasswordVisible() ? 'Hide' : 'Show' }}
          </button>
        </div>
      </label>
      <button
        class="w-full btn btn-primary btn-md lg:btn-lg login-submit"
        type="submit"
        [disabled]="isLoading"
        [class.loading]="isLoading"
      >
        <span *ngIf="isLoading" class="inline-block animate-spin mr-2">⏳</span>
        {{ isLoading ? spinnerMessage : 'Log In' }}
        <span class="fe fe-arrow-right" *ngIf="!isLoading"></span>
      </button>
      <a
        class="login-forgot-link login-forgot-link-below"
        href="/passport/reset-password-request-form"
        [class.pointer-events-none]="isLoading"
      >
        Forgot password?
      </a>
    </form>

    <div class="login-footer-block">
      <p class="login-footer">
        Don't have an account?
        <a class="login-footer-link" href="https://buspro.biz#contact">Contact Sales</a>
      </p>
      <p class="login-footer-support">
        Let's get your company onboard to experience BUSPRO
      </p>
    </div>
  </div>
</nz-spin>
